import React, { useState, useEffect, useContext, useRef } from "react";
import BredCrumb from "./BredCrumb";
import InternalBaseBanner from "./InternalBaseBanner";
import axios from "axios";
import { DrtContext } from "../../context/DrtContext";
import { useTitle } from "../../services/PageTitle";
import Captcha from "react-numeric-captcha";
import { useFormik } from "formik";
import { apiStagingOutdoorUrl } from "../../constants";
import { axiosBaseURLExternal } from "../../httpCommon";

const RTI = () => {
  useTitle("RTI");
  const [loading, setLoading] = useState(false);
  const { EncryptDecrypt } = useContext(DrtContext);

  const [captchaStatus, setCaptchaStatus] = useState(false);
  const capt = useRef();

  const [drtLocations, setDrtLocations] = useState([]);
  const refFromDate = useRef("");
  const refToDate = useRef("");
  const [caseDetail, setCaseDetail] = useState([]);
  const [error, setError] = useState(false);

  const fetchRtiDetail = async (url, data) => {
    try {
      setLoading(true);
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      const response = await axios.post(
        `${apiStagingOutdoorUrl}/${url}`,
        data,
        config
      );
      setCaseDetail(response.data);
    } catch (error) {
      console.error("Error response:", error.response ? error.response.data : error.message);
      setCaseDetail([]);
      setError(true);
    }
    setLoading(false);
  };

  const initialValues = {
    schemeNameDratDrtId: "",
    fromDate: "",
    toDate: "",
  };

  const fetchDrtLocation = async () => {
    const res = await axiosBaseURLExternal.post("getDrtDratScheamName");
    const sortedLocation = res.data.sort((a, b) =>
      a.SchemaName > b.SchemaName ? 1 : b.SchemaName > a.SchemaName ? -1 : 0
    );
    setDrtLocations(sortedLocation);
  };

  useEffect(() => {
    fetchDrtLocation();
  }, []);

  const validate = (values) => {
    let errors = {};
    if (!values.schemeNameDratDrtId) errors.schemeNameDratDrtId = "Required";
    if (!values.fromDate) errors.fromDate = "Required";
    if (!values.toDate) errors.toDate = "Required";
    return errors;
  };

  const onSubmit = (values) => {
    if (!captchaStatus) {
      alert("Please enter a valid captcha.");
      return;
    }

    const caseDetailData = {
      schemeNameDrtId: values.schemeNameDratDrtId,
      fromDate: refFromDate.current,
      toDate: refToDate.current,
    };

    fetchRtiDetail("getRti", caseDetailData);
    setCaptchaStatus(false);
    capt.current.refresh();
  };

  const formik = useFormik({ initialValues, onSubmit, validate });

  const locationAndDate = (value, name) => {
    if (name === "fromDate") refFromDate.current = value;
    if (name === "toDate") refToDate.current = value;
  };

  if (loading) return <h6 className="loader">Loading......</h6>;

  return (
    <>
      <InternalBaseBanner title={"RTI"} />
      <BredCrumb title={"RTI"} />
      <div className="common-bg">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="about-content">
                <h6>RTI</h6>

                <form onSubmit={formik.handleSubmit} className="w-100" aria-label="RTI search form">
                  <div className="form-row row">
                    {/* DRT Select */}
                    <div className="form-group col-md-4">
                      <label htmlFor="schemeNameDratDrtId" className="mandatory">
                        DRT
                      </label>
                      <select
                        className="form-control"
                        id="schemeNameDratDrtId"
                        name="schemeNameDratDrtId"
                        onChange={formik.handleChange}
                        value={formik.values.schemeNameDratDrtId}
                        onBlur={formik.handleBlur}
                        aria-label="Select DRT location"
                      >
                        <option value="">Select DRT Location</option>
                        {drtLocations &&
                          drtLocations
                            .filter((item) => parseInt(item.schemeNameDrtId) < 105)
                            .map((item, index) => (
                              <option value={`${item.schemeNameDrtId}`} key={index}>
                                {item.SchemaName}
                              </option>
                            ))}
                      </select>
                      {formik.touched.schemeNameDratDrtId && formik.errors.schemeNameDratDrtId ? (
                        <div className="error">{formik.errors.schemeNameDratDrtId}</div>
                      ) : null}
                    </div>

                    {/* From Date */}
                    <div className="form-group col-md-4">
                      <label htmlFor="fromDate" className="mandatory">
                        From Date
                      </label>
                      <input
                        className="form-control"
                        type="date"
                        id="fromDate"
                        name="fromDate"
                        aria-label="Select from date"
                        onChange={(e) => {
                          formik.handleChange(e);
                          locationAndDate(e.target.value, e.target.name);
                        }}
                        value={formik.values.fromDate}
                        onBlur={formik.handleBlur}
                        autoComplete="off"
                      />
                      {formik.touched.fromDate && formik.errors.fromDate ? (
                        <div className="error">{formik.errors.fromDate}</div>
                      ) : null}
                    </div>

                    {/* To Date */}
                    <div className="form-group col-md-4">
                      <label htmlFor="toDate" className="mandatory">
                        To Date
                      </label>
                      <input
                        className="form-control"
                        type="date"
                        id="toDate"
                        name="toDate"
                        aria-label="Select to date"
                        onChange={(e) => {
                          formik.handleChange(e);
                          locationAndDate(e.target.value, e.target.name);
                        }}
                        value={formik.values.toDate}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.toDate && formik.errors.toDate ? (
                        <div className="error">{formik.errors.toDate}</div>
                      ) : null}
                    </div>

                    {/* Captcha Section */}
                    <div className="form-group col-md-4 main-menu-captcha capcha-sec">
                      <label htmlFor="captchaInput">Captcha</label>
                      <div className="col-sm-12 px-0 d-flex">
                        <Captcha
                          onChange={(status) => setCaptchaStatus(status)}
                          ref={capt}
                          required
                          aria-label="Captcha verification"
                        />
                        <button
                          type="submit"
                          disabled={!captchaStatus}
                          className="btn btn-reload"
                          aria-label="Search RTI details"
                        >
                          <i className="fas fa-search" aria-hidden="true"></i>
                        </button>
                      </div>
                      {!captchaStatus ? <div className="captcha-text">Enter valid captcha</div> : null}
                    </div>
                  </div>
                </form>

                {caseDetail.length === 0 ? null : (
                  <div className="table-responsive mt-5">
                    <table className="table table-striped common-table bluetable">
                      <thead>
                        <tr>
                          <th>Sr. No.</th>
                          <th>Subject</th>
                          <th>Document</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {caseDetail.length > 0 ? (
                          caseDetail.map((item, index) => (
                            <tr key={item.id}>
                              <td>{index + 1}</td>
                              <td>{item.subject}</td>
                              <td>
                                <a
                                  href={item.dailyOrderPdf}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  aria-label={`View PDF for ${item.subject}`}
                                >
                                  <i className="fas fa-file" aria-hidden="true"></i> View PDF
                                </a>
                              </td>
                              <td>{new Date(item.entry_date).toLocaleDateString()}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="4">Select Above Location and date for RTI</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RTI;
